/**
 * Every feature's routes, in sidebar order. Feature teams edit only their own routes.tsx; adding a
 * new feature folder means adding one import here (integration lead).
 */
import { routes as assistantRoutes } from "@/features/assistant/routes";
import { routes as benchRoutes } from "@/features/bench/routes";
import { routes as complianceRoutes } from "@/features/compliance/routes";
import { routes as dashboardRoutes } from "@/features/dashboard/routes";
import { routes as formulasRoutes } from "@/features/formulas/routes";
import { routes as importsRoutes } from "@/features/imports/routes";
import { routes as inventoryRoutes } from "@/features/inventory/routes";
import { routes as knowledgeRoutes } from "@/features/knowledge/routes";
import { routes as labelsRoutes } from "@/features/labels/routes";
import { routes as publishedFormulasRoutes } from "@/features/published-formulas/routes";
import { routes as materialsRoutes } from "@/features/materials/routes";
import { routes as purchasingRoutes } from "@/features/purchasing/routes";
import { routes as reviewRoutes } from "@/features/review/routes";
import { routes as settingsRoutes } from "@/features/settings/routes";
import { routes as suppliersRoutes } from "@/features/suppliers/routes";
import { routes as suppliesRoutes } from "@/features/supplies/routes";
import type { AppRoute } from "@/lib/routing";

export const featureRoutes: AppRoute[] = [
  ...dashboardRoutes,
  ...materialsRoutes,
  ...publishedFormulasRoutes,
  ...knowledgeRoutes,
  ...reviewRoutes,
  ...inventoryRoutes,
  ...importsRoutes,
  ...formulasRoutes,
  ...complianceRoutes,
  ...benchRoutes,
  ...labelsRoutes,
  ...purchasingRoutes,
  ...suppliesRoutes,
  ...suppliersRoutes,
  ...assistantRoutes,
  ...settingsRoutes,
];
